// workflow.js

import React, { useEffect, useRef, useState } from "react";
import { callWorkflow } from './callworkflow';
import AgentOpsContainer from '../components/AgentOpsContainer';

function collapseDoubleSlashes(href) {
  return href.replace(/([^:])\/{2,}/g, "$1/"); // don't touch "http://", only path parts
}
export default function Workflow() {
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [iframeSrc, setIframeSrc] = useState("");
  const iframeRef = useRef(null);
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    go();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
const go = async () => {
    setErr('');
    setLoading(true);
    try {
      const resp = await callWorkflow();
      localStorage.setItem("ap_token",resp.token)
      localStorage.setItem("projectId",resp.projectId);
      if (resp.success && resp.redirectUrl) {
        const proxied = collapseDoubleSlashes(resp.redirectUrl);
        setIframeSrc(proxied);
        setPageLoading(false);
      } else {
        throw new Error('Unexpected /workflow response.');
      }
    } catch (e) {
      console.error("An error occurred during the workflow:", e);
    } finally {
      setLoading(false);
    }
  };


const handleLogout = () => {
    console.log('Logout clicked');
  };
return (
  <AgentOpsContainer
    loading={pageLoading}
    loadingMessage="Loading AgentOps Studio..."
    title=""
    subtitle=""
    onLogout={handleLogout}
  >

      {iframeSrc ? (
        <iframe
          ref={iframeRef}
          className="agentops-frame"
          title="AgentOps Studio"
          src={iframeSrc}
          allow="clipboard-read; clipboard-write; microphone; camera"
          // sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-downloads"
        />
      ) : (
        !loading && !err && (
          <div style={{ opacity: 0.7 }}>Loading AgentOps Studio...</div>
        )
      )}

  </AgentOpsContainer>
);

}

